namespace TabAurous.OMS {
    export interface LedgerPostingForm {
        TransDate: Serenity.DateEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        VoucherNo: Serenity.StringEditor;
        LedgerId: Serenity.IntegerEditor;
        Debit: Serenity.DecimalEditor;
        Credit: Serenity.DecimalEditor;
        DetailsId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
        InvoiceNo: Serenity.StringEditor;
        ChequeNo: Serenity.StringEditor;
        ChequeDate: Serenity.DateEditor;
    }

    export class LedgerPostingForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.LedgerPosting';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!LedgerPostingForm.init)  {
                LedgerPostingForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.StringEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(LedgerPostingForm, [
                    'TransDate', w0,
                    'VoucherTypeId', w1,
                    'VoucherNo', w2,
                    'LedgerId', w1,
                    'Debit', w3,
                    'Credit', w3,
                    'DetailsId', w1,
                    'FinancialYearId', w1,
                    'InvoiceNo', w2,
                    'ChequeNo', w2,
                    'ChequeDate', w0
                ]);
            }
        }
    }
}
